<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/price' }">
        <app-i18n code="entities.price.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.price.importer.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.price.importer.title"></app-i18n>
      </h1>

      <app-importer storePath="price/importer"></app-importer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-price-importer-page',
};
</script>

<style>
</style>
